import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";
const win: any = window;
export const useUploadJson = () => {
    const [state, dispatch]: any = useContext(GlobalContext);
    const { rtl } = state;
    const dir = rtl ? "right" : "left";
    const { t } = useTranslation();
    const AuthorizationForm = dir === "right" ? `${win["download_form_url"]}/Authorization-Letter-Arabic.pdf` : `${win["download_form_url"]}/Authorization-Letter-English.pdf`;
    const EndUserInfoForm = dir === 'right' ? `${win["download_form_url"]}/EndUser-Form-Arabic.xlsx` : `${win["download_form_url"]}/EndUser-Form-English.xlsx`;
    const MNPFormDownload = dir === 'right' ? `${win["download_form_url"]}/MNP-Form-Arabic.xlsx` : `${win["download_form_url"]}/MNP-Form-English.xlsx`;
    const CSTConsentFormDownload = dir === 'right' ? `${win["download_form_url"]}/CITC-Form.pdf` : `${win["download_form_url"]}/CITC-Form.pdf`;
    const endUserSub = t("EndUser_subtitle").split('This Form')
    const TransferMobilySub = t("Transfer_Mobily_Document_Subtitle").split('This Form')
    const CSTConsentSub = t("CST_Consent_form_Subtitle").split('This Form')
    const getAuthFormSubtitle = (str: string) => {
        const splittedStr = str.split(t('The_Authorization_Letter_Form'));
        if (splittedStr.length === 2) {
            return (
                <>
                    <span>{splittedStr[0]}</span>
                    <a className="auth-letter-link" href={AuthorizationForm} role="button" download target="_blank" rel="noreferrer">
                        {t('The_Authorization_Letter_Form')}
                    </a>
                    <span>{splittedStr[1]}</span>
                </>
            )
        } else {
            return (
                <>
                    <a className="auth-letter-link" href={AuthorizationForm} role="button" download target="_blank" rel="noreferrer">
                        {t('The_Authorization_Letter_Form')}
                    </a>
                    <span>{splittedStr[0]}</span>
                </>
            )
        }
    }
    const uploadJson = [
        {
            rtl: rtl,
            downloadForm: false,
            title: t("Commercial_Registration"),
            subTitle: t("Commercial_Reg_Text"),
            uploadFileText: t("Upload_CR_Registration"),
            toolTipText: t("commercialReg_TooltipText"),
            downloadFileSrc: "",
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("FileType_Others_Error"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer"],
            productType: ["Voice", "Data", "Fiber", "SIP"],
            typeCode: "Z65",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ],
        },
        {
            rtl: rtl,
            downloadForm: false,
            title: t("VAT_registration_certificate"),
            subTitle: t("VAT_Reg_subtitle"),
            uploadFileText: t("Upload_CR_Registration"),
            toolTipText: t("commercialReg_TooltipText"),
            downloadFileSrc: "",
            sizeErrorText: t("SizeLimit_Text"),
            fileTypeErrorText: t("FileType_Others_Error"),
            filemaxErrorText: t("FileLimit_Validation"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer"],
            productType: ["Voice", "Data", "Fiber", "SIP"],
            typeCode: "Z65",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        },
        {
            rtl: rtl,
            downloadForm: true,
            title: t("Authorization_Letter"),
            subTitle: t("Authorization_Letter_subtitle").split("\n")
                .map((str, index) => {
                    switch (index) {
                        case 0:
                            return <p className='download-this-form'>
                                {getAuthFormSubtitle(str)}
                            </p>;
                        case 1:
                            return <a className="auth-letter-link d-block" href="https://mybusiness.chamber.sa/Login.aspx?ReturnUrl=%2f" target="_blank" rel="noreferrer">{str}</a>;
                        default:
                            return <a className="auth-letter-link d-block" href="https://user.saudichambers.sa/Auth/Login" target="_blank" rel="noreferrer">{str}</a>;
                    }
                }),
            uploadFileText: t("Upload_Authorization_form"),
            toolTipText: t("Authorization_TooltipText"),
            downloadFileSrc: AuthorizationForm,
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("FileType_Others_Error"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer"],
            productType: ["Voice", "Data", "Fiber", "SIP"],
            typeCode: "Z68",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        },
        {
            rtl: rtl,
            downloadForm: true,
            title: t("Enduser_title"),
            subTitle: <span>
                {endUserSub[0]}
                <a className="auth-letter-link" href={EndUserInfoForm} target="_blank" rel="noreferrer" role="button" download >
                    {t('This_form')}
                </a>
                {endUserSub[1]}
            </span>,
            uploadFileText: t("Upload_EndUser"),
            toolTipText: t("EndUser_subtitle"),
            downloadFileSrc: EndUserInfoForm,
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("File_XlsType_Text"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer", "existingcustomer"],
            productType: ["Voice", "Data"],
            typeCode: "Z115",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        },
        {
            rtl: rtl,
            downloadForm: true,
            title: t("Transfer_Mobily_Document"),
            subTitle: <span>
                {TransferMobilySub[0]}
                <a className="auth-letter-link" href={MNPFormDownload} target="_blank" rel="noreferrer" role="button" download >
                    {t('This_form')}
                </a>
                {TransferMobilySub[1]}
            </span>,
            uploadFileText: t("Upload_MNP_form"),
            toolTipText: t("Upload_MNP_form"),
            downloadFileSrc: MNPFormDownload,
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("File_XlsType_Text"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer", "existingcustomer"],
            productType: ["Voice", "Data"],
            typeCode: "Z78",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        },
        {
            rtl: rtl,
            downloadForm: true,
            title: t("CST_Consent_form_title"),
            subTitle: <span>
                {CSTConsentSub[0]}
                <a className="auth-letter-link" href={CSTConsentFormDownload} target="_blank" rel="noreferrer" role="button" download >
                    {t('This_form')}
                </a>
                {CSTConsentSub[1]}
            </span>,
            uploadFileText: t("Upload_EndUser"),
            toolTipText: t("EndUser_subtitle"),
            downloadFileSrc: EndUserInfoForm,
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("File_XlsType_Text"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer", "existingcustomer"],
            productType: ["Voice", "Data"],
            typeCode: "Z115",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        },
        {
            rtl: rtl,
            downloadForm: true,
            title: t("MNP_Form"),
            subTitle: t("MNP_Portability_Text"),
            uploadFileText: t("Upload_MNP_form"),
            toolTipText: t("Authorization_TooltipText"),
            downloadFileSrc: MNPFormDownload,
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("FileType_Others_Error"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer", "existingcustomer"],
            productType: [''],
            fileType: [
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-outlook",
                "text/plain",
                "image/jpeg",
                "image/png",
                ".png",
                ".jpg",
                ".msg",
                ".pdf",
                ".xlsx",
                ".pptx",
                ".docx",
                ".txt",
                "message/rfc822",
            ],
            typeCode: "Z78",
        },
        {
            rtl: rtl,
            downloadForm: true,
            title: t("CITC_Form"),
            subTitle: t("CITC_text"),
            uploadFileText: t("Upload_CITC_form"),
            toolTipText: "Commercial Registration",
            downloadFileSrc: `${win["download_form_url"]}/CITC-Form.pdf`,
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("FileType_Others_Error"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer", "existingcustomer"],
            productType: [''],
            typeCode: "Z79",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        },
        {
            rtl: rtl,
            downloadForm: false,
            title: t("GOSI_Certificate"),
            subTitle: t("GOSI_text"),
            uploadFileText: t("Upload_GOSI_Certificate"),
            toolTipText: t("GOSI_text"),
            downloadFileSrc: "",
            sizeErrorText: t("SizeLimit_Text"),
            filemaxErrorText: t("FileLimit_Validation"),
            fileTypeErrorText: t("FileType_Others_Error"),
            selectFileError: false,
            file: {},
            value: "",
            fileSelected: false,
            isInvalid: false,
            userType: ["newcustomer", "existingcustomer"],
            productType: [''],
            typeCode: "Z80",
            fileType: [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-outlook",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                ".jpg",
                ".png",
                ".pdf",
                ".xlsx",
                ".docx",
                ".txt",
                ".msg",
                "message/rfc822",
            ]
        }
    ];
    return uploadJson;
}